import React from 'react';
/**
 * @type {import('./types').usePublicLinkHookReturnType}
 */

export var defaultValue = {
  loading: true,
  error: null,
  value: null,
  publicId: null
};
var PublicLinkContext = React.createContext(defaultValue);
export default PublicLinkContext;